import api from './client';

export const companyAPI = {
    getPublic: (companyId) => api.get(`/company/public/${companyId}`),
};
export const chatAPI = {
    send: (body) => api.post('/chat/message', body),
};
export const appointmentsAPI = {
    create: (body) => api.post('/appointments', body),
    listByPhone: (companyId, callerPhone) =>
        api.get('/appointments/by-phone', { params: { companyId, callerPhone, limit: 50 } }),
};
export const ordersAPI = {
    create: (body) => api.post('/orders', body),
    listByPhone: (companyId, callerPhone) =>
        api.get('/orders/by-phone', { params: { companyId, callerPhone, limit: 50 } }),
};
export const productsAPI = {
    list: (companyId) => api.get('/products/public', { params: { companyId } }),
};
export const eventsAPI = {
    list: (companyId, params) => api.get('/events', { params: { companyId, ...params } }),
};
export const flightsAPI = {
    list: (companyId, params) => api.get('/flights', { params: { companyId, ...params } }),
};
export const ticketsAPI = {
    issue: (body) => api.post('/tickets/issue', body),
    myTickets: (companyId, callerPhone) =>
        api.get('/tickets/by-phone', { params: { companyId, callerPhone, limit: 50 } }),
};
export const adsAPI = {
    listActive: (companyId) => api.get('/ads/active', { params: { companyId } }),
    recordImpression: (adId) => api.post(`/ads/${adId}/impression`),
    recordClick: (adId) => api.post(`/ads/${adId}/click`),
    recordSkip: (adId) => api.post(`/ads/${adId}/skip`),
};
